import { useState } from "react";
import { solveCaptcha } from "./captchaLogic";
import CAPTCHA_PROTECTED_DATA from "./captchaProtectedData";
import "./Imprint.css"
import { useTranslations } from "../../i18n";


export function Imprint() {
    const t = useTranslations();
    const [data, setData] = useState<any | null>(null);
    async function trySolve() {
        const answer = document.querySelector<HTMLInputElement>('input[name="captcha"]')!.value;
        const data = await solveCaptcha(CAPTCHA_PROTECTED_DATA, answer);
        setData(data ? JSON.parse(data) : null);
    }
    return (
        <div className="imprint-columns">
            <div className="imprint-address">
                {t.imprintResponsible}<br />
                Georg Wicke-Arndt<br />
                <CensoredElement value={data?.["address1"]} placeholder="Beispielstraße 123" /><br />
                <CensoredElement value={data?.["address2"]} placeholder="12345 Neustadt" /><br />
                Tel.: <CensoredElement value={data?.["tel"]} placeholder="0123 456789" /><br />
                E-Mail: <CensoredElement value={data?.["email"]} placeholder="georg@example.com" /><br />
            </div>
            <div className="imprint-captcha">
                <h3>{t.imprintAreYouARobot}</h3>
                {t.imprintQuestion}
                <br />
                <br />
                <i>{CAPTCHA_PROTECTED_DATA.question["deDe"]}</i><br />
                <input type="text" name="captcha" placeholder="Type answer here"
                    onChange={e => trySolve()} />
                {/* <button onClick={trySolve}>Entschlüsseln</button> */}
            </div>
        </div>
    );
}

function CensoredElement({ value, placeholder }: { value: string | null, placeholder: string }) {
    return (
        <span className={value ? "" : "imprint-censored"}>
            {value ?? placeholder}
        </span>
    );
}